export default {
  content: {
    title: 'Merci!',
    description: 'Vous avez fait votre bonne action du jour en rendant {{firstName}} heureux ',
  },
  joinCommunity: 'Pourquoi ne pas rejoindre la communauté?',
  downloadButton: 'Télécharger SOSAFE',
  contactAgain: 'Contactez à nouveau {{firstName}}',
};
